// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"498":"701e93e4","699":"83d610b4"}[chunkId] + ".chunk.css";
};